import React, { FunctionComponent } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useParams } from "react-router-dom";
import Header from "../shared/header";
import ChangePasswordForm from "../shared/forms/change-password";

interface UsersCahngeFormProps {}

/**
 * UsersChangeForm is a React component that provides a password change interface for users.
 * It displays a form specifically for changing user passwords.
 * 
 * @component
 * @returns {JSX.Element} A component that renders a password change form
 * 
 * @features
 * - Responsive layout
 * - Password change form integration
 */
const UsersCahngeForm: FunctionComponent<UsersCahngeFormProps> = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const { id } = useParams();

  return (
    <>
      <Box
        sx={{
          marginTop: isNonMobile ? "40px" : "60px",
        }}
      >
        <Header title={"Kennwort ändern"} />
        <ChangePasswordForm userId={id} />
      </Box>
    </>
  );
};

export default UsersCahngeForm;
